module.exports = __webpack_public_path__ + "static/img/tiankong.6d4bb89.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/newCourse/tiankong.png
// module id = KLco
// module chunks = 96